import { SLICE_NAME } from 'config/type';

export const GET_LIST_NOTIFICATION = SLICE_NAME.NOTIFICATION + 'GET_LIST_NOTIFICATION';
export const READ_NOTIFICATION = SLICE_NAME.NOTIFICATION + 'READ_NOTIFICATION';
export const READ_ALL_NOTIFICATION = SLICE_NAME.NOTIFICATION + 'READ_ALL_NOTIFICATION';
